import React, {
  useEffect,
  useState,
  useCallback,
  useContext,
  useRef,
} from "react";
import "./inventoryManagement.css";
import { Wrapper } from "../../../../components/Wrapper/Wrapper";
import { useNavigate } from "react-router-dom";
import { environment } from "../../../../environments/environment";

import {
  AccordionDetails,
  Breadcrumbs,
  Checkbox,
  Divider,
  FormControlLabel,
  Link,
  Tooltip,
} from "@mui/material";
import { AccordionComponent } from "../Accordion/AccordionComponent";
import {
  getStoreOptions,
  iconsStoreMap,
  storeOptionsMenu,
} from "../../Services/storeOptionsDataService";
import { Dropdowns } from "../../../../components/Dropdowns/Dropdowns";
import { PartList } from "../PartList/PartList";
import { getModuleSelectedId } from "../../../../services/localStorageService";
import { NavBar } from "../../../../components/NavBar/NavBar";
import CheckboxField from "../../../../components/Checkbox/CheckboxField";
import { CustomTag } from "../../../../components/Tags/CustomTag";
import { dropdownConfig } from "../../../../services/dropdownsConfigService";
import Filters from "../../../../components/Filters/Filters";
import {
  InventoryManagementContext,
  InventoryManagementProvider,
} from "../../context/InventoryManagementContext";
import PhoneIcon from "@mui/icons-material/Phone";
import FavoriteIcon from "@mui/icons-material/Favorite";
import PersonPinIcon from "@mui/icons-material/PersonPin";
import PhoneMissedIcon from "@mui/icons-material/PhoneMissed";
import Box from "@mui/material/Box";
import CustomTabs from "../../../../components/Tabs/Tabs";
import { useDispatch } from "react-redux";
import {
  addTab,
  clearActiveTab,
} from "../../../../redux/features/TabsManager/tabSlice";
import { FiltersManager } from "../../../../components/FiltersManager/FiltersManager";
import { SortingProvider } from "../../../../contexts/SortingContext";
import { SortingButton } from "../../../../components/Sorting/SortingButton";

const FilterContainer = ({ filtersOpen, setFiltersOpen }) => {
  const { onFiltersChange } = useContext(InventoryManagementContext);
  return (
    <Filters
      extOpen={filtersOpen}
      openChange={(value) => setFiltersOpen(value)}
      onApplyFilters={onFiltersChange}
      hideToggle
    />
  );
};
const ToggleViewButtons = ({ tabView, handlerTabsOptions }) => {
  const { setTabIndex, setSortingOrder, tabIndexForce } = useContext(
    InventoryManagementContext
  );
  const setTabView = (value) => {
    setTabIndex(value);
    setSortingOrder("part_number");
    handlerTabsOptions(value);
  };

  useEffect(() => {
    setTabIndex(tabIndexForce);
    setSortingOrder("part_number");
    handlerTabsOptions(tabIndexForce);
  }, [tabIndexForce]);

  return (
    <div className="inventoryManagement-view-options">
      <Tooltip className="custom-tooltip" title={"Single list view"} arrow>
        <button
          className={`toogle-view ${tabView == 0 ? "active-toogle" : ""}`}
          onClick={() => setTabView(0)}
        >
          <i className="icon-list"></i>
        </button>
      </Tooltip>
      <Tooltip className="custom-tooltip" title={"Tabs view"} arrow>
        <button
          className={`toogle-view ${tabView > 0 ? "active-toogle" : ""}`}
          onClick={() => setTabView(1)}
        >
          <i className="icon-tabs"></i>
        </button>
      </Tooltip>
    </div>
  );
};

const SearchBarContainer = () => {
  const [inputValue, setInputValue] = useState("");
  const [debouncedValue, setDebouncedValue] = useState("");
  const { onSearch } = useContext(InventoryManagementContext);

  const didMount = useRef(false);
  const handleChange = (event) => {
    setInputValue(event.target.value);
  };
  useEffect(() => {

    const handler = setTimeout(() => {
      setDebouncedValue(inputValue);
    }, 1000); // 500ms delay

    return () => {
      clearTimeout(handler);
    };
  }, [inputValue]);

  useEffect(() => {

    if (!didMount.current) {
      didMount.current = true; // Evita la primera ejecución
      return;
    }
    onSearch(debouncedValue);
  }, [debouncedValue]);
  return <input placeholder="Search" onChange={handleChange} />;
};

const CustomTabPanel = ({ children, value, index, ...other }) => {
  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`tabpanel-${index}`}
      aria-labelledby={`tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box className="tab-info" p={3}>
          {children}
        </Box>
      )}
    </div>
  );
};
function generateUUID() {
  return crypto.randomUUID();
}
export const InventoryManagement = () => {
  useEffect(() => {

    dispatch(
      addTab({
        icon: "icon-inventory-management",
        color: "#29abe2",
        path: "/store/inventory-management",
        title: "Inventory Management",
        isPinned: false,
        componentKey: "InventoryManagement",
        id: 5,
        date: generateUUID(),
      })
    );
  }, []);
  const [filtersOpen, setFiltersOpen] = useState(false);
  const basePath = environment.basePath;
  const [value, setValue] = React.useState(0);

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  const handleChangeToggle = (newValue) => {
    setValue(newValue);
  };

  const navigate = useNavigate();

  const navegation = (path) => {
    navigate(basePath + path);
  };
  const dispatch = useDispatch();
  const clearTabsAndNavigate = (path) => {
    dispatch(clearActiveTab());
    navigate(path);
  };
  const dataBreadCrumbs = [
    <Link
      key={1}
      underline="hover"
      sx={{ color: "#000000", cursor: "pointer", fontSize: "var(--p-size)" }}
      onClick={() => clearTabsAndNavigate("/secure/customdashboard")}
    >
      Modules
    </Link>,
    <Link
      key={2}
      underline="hover"
      sx={{ color: "#000000", cursor: "pointer", fontSize: "var(--p-size)" }}
      onClick={() => clearTabsAndNavigate("/secure/store")}
    >
      Stores
    </Link>,
    <Link
      key={3}
      underline="none"
      sx={{ color: "#000000", cursor: "default", fontSize: "var(--p-size)" }}
    >
      Inventory Management
    </Link>,
  ];
  const tabsData = [
    {
      label: "Serialized Parts",
      icon: <i className="icon-part" />,
      position: "start",
    },
    {
      label: "Consumables",
      icon: <i className="icon-consumable" />,
      position: "start",
    },
    { label: "Kits", icon: <i className="icon-kits" />, position: "start" },
    {
      label: "Expendables",
      icon: <i className="icon-expandable" />,
      position: "start",
    },
    {
      label: "Reiparable",
      icon: <i className="icon-reiparable" />,
      position: "start",
    },
  ];
  function generateUUID() {
    return crypto.randomUUID();
  }

  const goBackDataObj = {
    icon: "icon-store_module_icon",
    color: "#EB9090",
    path: "/store",
    title: "Store",
    isPinned: false,
    componentKey: "Stores",
    id: -1,
    isModule: true,
    date: generateUUID(),
  };
  return (
    <InventoryManagementProvider>
      <SortingContainer>
        <div className="inventory-management-configuration-component">
          <div className="nav-header">
            <NavBarContainer
              dataBreadCrumbs={"/store/inventory-management"}
              moduleIcon={"icon-stores"}
              appIcon="icon-inventory-management"
              moduleColor="#29abe2"
              title={"Inventory Management"}
              menuTitle={"Stores"}
              moduleId={3}
              goBackData={goBackDataObj}
              isLocalSearch
              searchActions={<>
                <FiltersManager onButtonClick={() => setFiltersOpen(prev => !prev)} />
                <SortingButton/>
              </>}
              screenActions={<>
                <ToggleViewButtons
                  tabView={value}
                  handlerTabsOptions={handleChangeToggle}
                />
              </>}
            >
              {/* <button
              onClick={() => setFiltersOpen((prev) => !prev)}
              className="filter-toggle"
            >
              <h2>Filters</h2>
              <i className={`icon-arrow-down ${filtersOpen ? "open" : ""}`}></i>
            </button> */}
            </NavBarContainer>
          </div>

          <div className={`inventoryManagement-component-content`}>
            <div className="inventoryManagement-header">
              <FilterContainer
                filtersOpen={filtersOpen}
                setFiltersOpen={setFiltersOpen}
              />
              {/* <div className="inventoryManagement-header-content">
                <b>Inventory Management</b>
                <div className="search-bar-input">
                  <SearchBarContainer />
                  <i className="icon-search"></i>
                </div>
                <ToggleViewButtons
                  tabView={value}
                  handlerTabsOptions={handleChangeToggle}
                />
              </div> */}
            </div>
            {value == 0 && (
              <div className="global-list">
                <PartList />
              </div>
            )}
            {value > 0 && (
              <>
                <CustomTabs
                  tabsData={tabsData}
                  value={value}
                  contextInfo={InventoryManagementContext}
                  handleChange={handleChange}
                />
                <CustomTabPanel
                  value={value}
                  index={1}
                  className="serialized-list custom-tab-body"
                >
                  <PartList />
                </CustomTabPanel>
                <CustomTabPanel
                  value={value}
                  index={2}
                  className="consumbale-list custom-tab-body"
                >
                  <PartList />
                </CustomTabPanel>
                <CustomTabPanel
                  value={value}
                  index={3}
                  className="consumbale-list custom-tab-body"
                >
                  <PartList />
                </CustomTabPanel>
                <CustomTabPanel
                  value={value}
                  index={4}
                  className="consumbale-list custom-tab-body"
                >
                  <PartList />
                </CustomTabPanel>
                <CustomTabPanel
                  value={value}
                  index={5}
                  className="consumbale-list custom-tab-body"
                >
                  <PartList />
                </CustomTabPanel>
              </>
            )}
          </div>
          <div className="paginator-container"></div>
        </div>
      </SortingContainer>
    </InventoryManagementProvider>
  );
};

const SortingContainer = ({ children }) => {
  const { setSortingOrder, tabIndex, partList} = useContext(InventoryManagementContext);
  return (
    <SortingProvider onOrderChange={(e) => setSortingOrder(e)} properties={{
      part_number: "PN",
      ...(tabIndex !== 2 && { serial_number: "SN" }),
      company_name: "Company",
      batch_name: "Batch",
      quantity: "QTY",
      location_name: "Location",
      part_description: "PN Description",
    }} >
      {children}

    </SortingProvider>
  )

}

const NavBarContainer = ({ ...props }) => {
  const { onSearch, partList } = useContext(InventoryManagementContext);
  return (
    <NavBar
      searchInputProps={{
        onTextChange: (e) => onSearch(e)
      }}
      displayRecordsCount={true}
      totalRecords={partList?.length}
      {...props}
    />
  )

}